<template>
  <div class="container no-padding">
    <div class="klickpages-link">
      <div class="kp-folder-table-title">
        <div class="kp-folder-name">{{ $t('account.attributes.name') }}</div>
        <div class="kp-folder-updatedate">{{ $t('account.attributes.type') }}</div>
        <div class="kp-folder-updatedate">{{ $t('account.list.insert_date') }}</div>
        <div class="kp-folder-actions">{{ $t('account.list.actions') }}</div>
      </div>

      <div ui-tree-handle="" folder-drop="afterDrop" class="kp-list-item" v-if="accountList.length > 0">
        <item v-for="item in accountList" :key="item.id" :account="item"></item>
      </div>

      <div v-if="accountList.length == 0">
        <empty-board></empty-board>
      </div>
    </div>

    <edit-account></edit-account>
    <delete-account></delete-account>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import Item from './Item';
import EmptyBoard from './EmptyBoard';
import EditAccount from './EditAccount';
import DeleteAccount from './DeleteAccount';

export default {
  mounted() {
    this.getAccounts();
  },
  components: {
    Item,
    EmptyBoard,
    EditAccount,
    DeleteAccount,
  },
  methods: mapActions({
    getAccounts: 'account/get',
  }),
  computed: mapGetters({
    accountList: 'account/list',
  }),
};
</script>



// WEBPACK FOOTER //
// List.vue?a891b5e4